import { render, staticRenderFns } from "./faturas-proformas.vue?vue&type=template&id=afef9bba&scoped=true&"
import script from "./faturas-proformas.vue?vue&type=script&lang=js&"
export * from "./faturas-proformas.vue?vue&type=script&lang=js&"
import style0 from "./faturas-proformas.vue?vue&type=style&index=0&id=afef9bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef9bba",
  null
  
)

export default component.exports